import axios from "axios";

export const Axios = axios.create({
  withCredentials: true,
  // eslint-disable-next-line no-undef
  baseURL: BASE_URL
})